import React from "react";
import { strLang } from "./functions/strLang";
export default function NoResults() {
  return (
    <div>
      <p align="center">{strLang("noResults")}</p>
    </div>
  );
}
